<template>
    <div v-if="productData">
        <div v-if="isSofort || (!isStripeSourcePayment && hasPaymentPlans)"
             class="mb-3rem with-flexible-parts js-lw-flexible-wrapper js-same-content-child">

            <div class="lw-cols one-row one-row-tl one-row-tp multiple-rows-sl multiple-rows-sp mb-2rem">
                <div v-if="isSofort"
                     class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_12_of_12-sl mb-2rem-sl 
                            span_12_of_12-sp mb-2rem-sp no-padding">

                    <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                        {{ i18n.get('common.sign_up_what_country') }}
                    </div>

                    <div class="select-wrapper">
                        <select v-model="sofortCountry"
                                class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal 
                                       learnworlds-element">

                            <option v-for="(country, index) in stripeSofortCountries"
                                    :key="index"
                                    :value="country.value">
                                {{ country.name }}
                            </option>
                        </select>
                    </div>
                </div>

                <div v-if="!isStripeSourcePayment && hasPaymentPlans"
                     class="col flex-item span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_12_of_12-sl 
                            span_12_of_12-sp no-padding">

                    <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                        {{ i18n.get('common.payment_plans') }}
                    </div>

                    <div class="select-wrapper">
                        <select v-model="planId"
                                class="learnworlds-input learnworlds-input-normal learnworlds-input-solid-light 
                                       no-margin-bottom">

                            <option v-for="option in paymentPlansOptions" :value="option.value">
                                {{option.name}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <component class="mb-5rem" :is="childActiveComponent" ref="childComponent" v-bind="childComponentProps()"/>

        <div v-if="displayCoupon">
            <div class="learnworlds-overline-text learnworlds-element no-margin-bottom">
                {{ i18n.get('payments.coupon_title') }}
            </div>

            <div v-if="activeCoupon==null"
                 class="lw-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp align-items-stretch">

                <div class="col no-padding span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl 
                            span_12_of_12-sp flex-item">

                    <div class="lw-cols no-gutter with-input-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp">
                        <div class="col no-padding span_9_of_12 span_9_of_12-tl span_9_of_12-tp span_9_of_12-sl 
                                    span_8_of_12-sp flex-item">

                            <input class="learnworlds-input-solid-light learnworlds-input learnworlds-input-normal 
                                          learnworlds-element"
                                   type="text"
                                   name="coupon"
                                   ref="couponInput"/>
                        </div>

                        <div class="col no-padding span_3_of_12 span_3_of_12-tl span_3_of_12-tp span_3_of_12-sl 
                                    span_4_of_12-sp flex-item">

                            <button class="learnworlds-button learnworlds-element full-size 
                                           learnworlds-button-solid-brand learnworlds-button-normal nowrap"
                                    @click="redeemCouponAction">

                                {{ i18n.get('payments.coupon_redeem') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="lw-cols one-row one-row-tl one-row-tp one-row-sl multiple-rows-sp align-items-stretch">
                <div class="col no-padding span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl 
                            span_12_of_12-sp flex-item">

                    <div class="lw-cols no-gutter with-input-cols one-row one-row-tl one-row-tp one-row-sl one-row-sp">
                        <div class="col no-padding span_9_of_12 span_9_of_12-tl span_9_of_12-tp span_9_of_12-sl 
                                    span_8_of_12-sp flex-item">

                            <div class="learnworlds-main-text learnworlds-main-text-normal learnworlds-input-solid-light learnworlds-element with-flexible-parts align-items-center full-height">
                                
                                <div class="flexible-part ml-5">
                                    <span class="learnworlds-icon fas fa-check-circle"></span>
                                </div>

                                <div class="flexible-part mr-5">
                                    {{ i18n.get('payments.coupon_redeemed') }}: {{ couponDiscountedPrice }}
                                </div>

                            </div>

                        </div>

                        <div class="col no-padding span_3_of_12 span_3_of_12-tl span_3_of_12-tp span_3_of_12-sl 
                                    span_4_of_12-sp flex-item">

                            <button class="learnworlds-button learnworlds-element full-size 
                                           learnworlds-button-solid-brand learnworlds-button-normal nowrap"
                                    @click.stop="removeCouponAction">

                                {{ i18n.get('payments.coupon_remove') }}
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col no-padding span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl 
                            span_12_of_12-sp flex-item va-c learnworlds-align-center-sp"> 
                    
                    <span v-if="hasInterval" class="learnworlds-overline-text">
                        {{couponIntervalText}}
                    </span>
                </div>
            </div>

            <div v-if="couponErrors" class="learnworlds-main-text learnworlds-main-text-normal learnworlds-element lw-brand-text">
                <p v-for="error in couponErrors">
                    {{error.message}}
                </p>
            </div>
        </div>

        <div class="mt-6rem">
            <div>
                <label v-if="hasTerms" class="checkbox-label with-flexible-parts mt-0 mb-1rem">
                    <input class="checkbox flexible-part"
                           name="financialTerms"
                           type="checkbox"
                           v-model="acceptTerms"
                           v-validate="termsValidationRules"
                           :data-vv-as="i18n.get('payments.terms')"/>

                    <div class="checkbox-box lw-brand-border flexible-part">
                        <span class="learnworlds-icon learnworlds-heading3-small fas fa-check"></span>
                    </div>

                    <div class="flexible-part">
                        <div class="learnworlds-main-text learnworlds-main-text-small learnworlds-element">
                            {{ i18n.get('payments.agree_with') }} 
                            <a href="#" ref="termsLink">{{ i18n.get('payments.terms') }}</a>
                        </div>
                    </div>
                </label>

                <div class="learnworlds-main-text learnworlds-main-text-small learnworlds-element lw-brand-text">
                    {{ errors.first('financialTerms') }}
                </div>

                <label v-if="hasMarketingOptin" class="checkbox-label with-flexible-parts mt-1rem">
                    <input class="checkbox flexible-part"
                           name="marketingOptIn"
                           type="checkbox"
                           v-model="marketingOptIn"/>

                    <div class="checkbox-box lw-brand-border flexible-part">
                        <span class="learnworlds-icon learnworlds-heading3-small fas fa-check"></span>
                    </div>

                    <div class="flexible-part">
                        <div class="learnworlds-main-text  learnworlds-main-text-small learnworlds-element">
                            {{ i18n.get('common.sign_up_optin') }}
                        </div>
                    </div>
                </label>
            </div>
        </div>

        <div class="lw-cols align-items-center mt-6rem one-row one-row-tl one-row-tp one-row-sl multiple-rows-sp">
            <div class="col no-padding span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp 
                        learnworlds-align-center-sp mb-2rem-sp">

                <p class="learnworlds-main-text learnworlds-element learnworlds-main-text-large nowrap"
                   v-html="totalAmountDescription"></p>
            </div>

            <div class="col no-padding span_6_of_12 span_6_of_12-tl span_6_of_12-tp span_6_of_12-sl span_12_of_12-sp">
                <div class="js-same-content-wrapper learnworlds-button-wrapper lw-content-block">
                    <button @click="requestValidation"
                            class="full-width learnworlds-button learnworlds-button-large 
                            learnworlds-button-solid-brand learnworlds-element"
                            :class="{'btn-loading': loading}"
                            style="padding-left: 5rem; padding-right: 5rem;">

                        <div class="btn-loader a-i-c j-c-sb">
                            <div class="btn-loader-part part1"></div>
                            <div class="btn-loader-part part2"></div>
                            <div class="btn-loader-part part3"></div>
                        </div>

                        <span class="btn-lbl">
                            {{ confirmOrderLabel }}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters} from 'vuex';
    import axios from 'commonjs/axios';

    export default {
        name: "BaseGateway",

        props: {
            productData: {
                type: Object,
                default() {
                    return {};
                }
            },

            checkoutData: {
                type: Object,
                default() {
                    return {};
                }
            },

            billingInfo: {
                type: String,
                default() {
                    return null;
                }
            },

            product: {
                type: Object,
                default() {
                    return {};
                }
            },

            isAuthoring: {
                type: Boolean,
                default() {
                    return false;
                }
            },

            coupon: {
                type: String,
                default() {
                    return null;
                }
            },

            hideCoupon: {
                type: Boolean,
                default() {
                    return false;
                }
            },

            paymentType: {
                type: String,
                default() {
                    return false;
                }
            },

            loading: {
                type: Boolean,
                default() {
                    return false;
                }
            }
        },

        data() {
            return {
                activeCoupon: null,
                couponErrors: null,
                acceptTerms: false, //Todo change this to false
                componentErrors: [],
                sofortCountry: null,
                marketingOptIn: false,
            };
        },

        computed: {
            ...mapState([
                'clientURL',
                'stripeSofortCountries',
                'activeStripeSourcePaymentMethods',
                'financialTerms',
                'userSignUpFields',
                'imagePath'
            ]),
            ...mapGetters('user', [
                'isLoggedIn'
            ]),
            productType() {
                switch (this.productData.type) {
                    case 'Model\\Bundle':
                        return 'bundle';
                    case 'Model\\Subscription':
                        return 'subscription';
                    default:
                        return 'course';
                }
            },

            finalPrice() {
                let price = this.productData.price;

                if (this.productData.discountFlag) {
                    price = this.productData.discountPrice;
                }

                if (this.activeCoupon) {
                    price = this.activeCoupon.price
                }

                return price;
            },

            totalAmountDescription() {
                return `${this.i18n.get('payments.total')} ${this.formatPrice(this.finalPrice)}`;
            },

            confirmOrderLabel() {
                return this.i18n.get('payments.buy');
            },

            isFree() {
                return this.finalPrice === 0;
            },

            getBaseUrl() {
                return this.clientURL + '/billing/' + this.gateway + '/pay/' + this.productData.id +
                    '?type=' + this.productType;
            },

            redirectUrl() {
                const baseUrl = this.getBaseUrl;
                let finalUrl = baseUrl;

                //we set couponId only if users input coupon number is legit and a price is returned from the call
                if (this.activeCoupon != null) {
                    finalUrl += "&coupon=" + this.activeCoupon.name;
                    //couponData holds coupon ajax info with the price
                    if (this.isFree) {
                        finalUrl += "&couponFree=1"
                    }
                }
                //Additional Data
                if (this.billingInfo) {
                    finalUrl += "&additional=" + encodeURIComponent(this.billingInfo.replace(/\r\n|\r|\n/g, "<br />"));
                }

                if (this.isStripeSourcePayment) {
                    finalUrl += this.getStripeSourcePaymentMethodFinalUrl;
                }

                return finalUrl;
            },

            subscriptionIntervalText() {
                if (this.checkoutData.interval > 1) {
                    return this.checkoutData.interval + ' ' +
                        this.i18n.get('common.' + this.checkoutData.interval_type);
                }

                return this.i18n.get('common.' + this.checkoutData.interval_type);
            },

            couponIntervalText() {
                if (this.activeCoupon.duration) {
                    return this.i18n.get('payments.coupon_stripe_' + this.activeCoupon.durationType) +
                        ' ' + this.activeCoupon.duration + ' '
                        + this.i18n.get('common.month' + (this.activeCoupon.duration > 1 ? 's' : ''));
                }

                return this.i18n.get('payments.coupon_stripe_' + this.activeCoupon.durationType);
            },

            couponDiscountedPrice() {
                const price = ((this.productData.discountFlag
                    ? this.productData.discountPrice
                    : this.productData.price) - this.activeCoupon.price).toFixed(2);

                return '- ' + this.formatPrice(price);
            },

            hasInterval() {
                return this.checkoutData.interval_type;
            },

            childActiveComponent() {
                return null;
            },

            hasCoupons() {
                return true;
            },

            hasPaymentPlans() {
                return false;
            },

            isSofort() {
                return this.paymentType === 'sofort';
            },

            isStripeSourcePayment() {
                return this.activeStripeSourcePaymentMethods.includes(this.paymentType);
            },

            getStripeSourcePaymentMethodFinalUrl() {
                var url = `&sourceType=${this.paymentType}`;

                if (this.isSofort) {
                    return `${url}&sofortCountry=${this.sofortCountry}`;
                }

                return url;
            },

            hasMarketingOptin() {
                return (!this.isLoggedIn)
                    ? typeof this.userSignUpFields.find(field => field.name === 'optin') !== 'undefined'
                    : false;
            },

            hasTerms() {
                // When the user is Logged in we follow the financial Terms in order to show or not the terms
                // When the user is Logged out we check first of all the finacial terms if it is false then we check if there is accept terms in signup fields
                return (this.financialTerms)
                    ? this.financialTerms
                    : (!this.isLoggedIn)
                        ? typeof this.userSignUpFields.find(field => field.name === 'terms') !== 'undefined'
                        : false;
            },

            termsValidationRules() {
                // When the user is Logged in we follow the financial Terms in order to show or not the terms
                // When the user is Logged out we check first of all the finacial terms if it is false then we check if there is accept terms in signup fields and it is required
                // sooory
                return ((this.financialTerms)
                        ? this.financialTerms
                        : (!this.isLoggedIn)
                            ? typeof this.userSignUpFields.find(field => field.type === 'terms' && field.required) !== 'undefined'
                            : false
                )
                    ? 'required'
                    : '';
            },

            displayCoupon() {
                return this.hasCoupons && !this.hideCoupon;
            }
        },

        mounted() {
            this.sofortCountry = this.stripeSofortCountries[0].value;
            this.initTermsModal();
        },

        methods: {
            initCheckout() {
                console.log('product', this.product);
                console.log('Product Data', this.productData);
                console.log('Redirect Url', 'http:' + this.redirectUrl);
                window.location.href = this.redirectUrl;
            },

            redeemCouponAction() {
                if (this.loading) {
                    return;
                }

                this.redeemCoupon(this.$refs['couponInput'].value.trim());
            },

            removeCouponAction() {
                if (this.loading) {
                    return;
                }

                this.redeemCoupon(null);
            },

            redeemCoupon(coupon) {
                if (this.isAuthoring) {
                    return;
                }

                this.couponErrors = null;

                if (!coupon) {
                    this.activeCoupon = null;
                    this.$emit('setCoupon', null);
                    return;
                }

                this.retrieveCouponData(coupon).then(response => {
                    if (response.data.success) {
                        this.activeCoupon = {
                            name: coupon,
                            duration: response.data.duration || null,
                            durationType: response.data.durationType || null,
                            price: response.data.price
                        };
                        this.$emit('setCoupon', coupon);
                    } else {
                        this.couponErrors = response.data.errors;
                    }
                })
            },

            retrieveCouponData(coupon) {
                //Todo move to store?                
                return axios.get(`${server}promotions/${coupon}/${this.productData.id}?type=${this.productType}`);
            },

            formatPrice(price) {
                return `${this.productData.currency}${price}`;
            },

            validate() {
                return new Promise((resolve, reject) => {
                    this.$validator.validateAll().then(result => {
                        if (!result) {
                            reject();
                        }
                        resolve();
                    });
                });
                // return this.acceptTerms;
            },

            requestValidation() {
                if (this.loading) {
                    return;
                }
                this.$emit('requestValidation');
            },

            childComponentProps() {
                return {};
            },

            setLoading(value) {
                this.$emit('setPaymentLoading', {loading: value});
            },

            setErrors(errors) {
                this.componentErrors = errors;
            },

            initTermsModal() {
                $(this.$refs['termsLink']).fancybox({
                    "type": "iframe",
                    fitToView: false,
                    autoSize: false,
                    autoDimensions: false,
                    "height": "80%",
                    "href": "/pages/terms",
                    afterLoad: function () {
                        var $pageWrapperClone = $('body', $('.fancybox-iframe').contents())
                            .find('#pageContent').clone();
                        $pageWrapperClone.find('.lw-topbar, .lw-footer').hide();
                        $('body', $('.fancybox-iframe').contents())
                            .find("*").remove();
                        $('body', $('.fancybox-iframe').contents())
                            .append($pageWrapperClone);
                    },
                });
            }
        },

        watch: {
            productData: {
                immediate: true,
                handler(newVal, oldVal) {
                    //this watcher is only for the first productData setup                    
                    if ((oldVal == null || !oldVal.id) && typeof newVal != 'undefined' && newVal.id) {
                        this.redeemCoupon(this.product.coupon);
                    }
                }
            },

            componentErrors: {
                handler(newVal, oldVal) {
                    if (newVal.length) {
                        newVal.forEach(error => {
                            displayError([error]);
                        });
                        this.componentErrors.splice(0, this.componentErrors.length);
                    }
                }
            },

            "product.coupon": {
                handler(val) {
                    this.redeemCoupon(val);

                }
            },

            acceptTerms: {
                immediate: true,
                handler(value) {
                    if (this.hasTerms) {
                        this.$emit('updateAuthenticationForm', {terms: value});
                    }
                }
            },

            marketingOptIn: {
                immediate: true,
                handler(value) {
                    if (this.hasMarketingOptin) {
                        this.$emit('updateAuthenticationForm', {optin: value});
                    }
                }
            }
        }
    }
</script>

